import { combineReducers } from 'redux';
import types from './types';

//避難所名
const shelterName = (state = '', action) => {
  switch (action.type) {
    case types.SET_SHELTERT_NAME:
      return action.shelterName;
    default:
      return state;
  }
};

//世帯情報
const setaiInfo = (state = [], action) => {
  switch (action.type) {
    case types.SET_SETAI_INFO:
      return action.setaiInfo;
    default:
      return state;
  }
};

//年一覧
const yearList = (state = [], action) => {
  switch (action.type) {
    case types.SET_YEAR_LIST:
      return action.yearList;
    default:
      return state;
  }
};

//個人情報一覧
const kojinInfo = (state = [], action) => {
  switch (action.type) {
    case types.SET_KOJIN_INFO:
      return action.kojinInfo;
    default:
      return state;
  }
};

//個人情報詳細
const kojinInfoDetail = (state = {}, action) => {
  switch (action.type) {
    case types.SET_KOJIN_INFO_DETAIL:
      return action.kojinInfoDetail;
    default:
      return state;
  }
};

const reducer = combineReducers({
  yearList,
  shelterName,
  kojinInfo,
  setaiInfo,
  kojinInfoDetail
});
export default reducer;
